jQuery(document).ready(function(){
	$('#filter_btn2').click(function(){
		$('#filter_col').toggleClass('open');
		$('#products_col').toggleClass('open');
	});
});